import { ConditionCardWrapper } from "../../../views/UIelems/v2/conditionsCards/ConditionCardWrapper";

export const ImageTile = ({ tiles }) => {
	return <ConditionCardWrapper items={tiles} />;
};
